import { render, staticRenderFns } from "./GrundUndBoden.vue?vue&type=template&id=1f477ec1&"
import script from "./GrundUndBoden.vue?vue&type=script&lang=ts&"
export * from "./GrundUndBoden.vue?vue&type=script&lang=ts&"
import style0 from "./GrundUndBoden.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports